// extracted by mini-css-extract-plugin
module.exports = {"region":"region_region__W4w8O"};